import { render, staticRenderFns } from "./AmazonPayButton.vue?vue&type=template&id=d4b605ce&"
import script from "./AmazonPayButton.vue?vue&type=script&lang=js&"
export * from "./AmazonPayButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports